import * as React from 'react';
import 'fontsource-roboto';
import '../app.css';
import {
  Menu, MenuItem,
} from '@material-ui/core';

interface RepairActionMenuProps {
  repairId: string;
  anchorEl: HTMLElement;
  handleMarkEmpty: (id: string) => void;
  handleMarkUnlisted: (id: string) => void;
  handleMarkAsHighPriority: null | ((id: string) => void);
  handleClose: () => void;
}

const RepairActionMenu: React.FC<RepairActionMenuProps> = (
  {
    repairId, anchorEl, handleMarkEmpty, handleMarkUnlisted, handleMarkAsHighPriority, handleClose,
  },
) => (
  <Menu
    anchorEl={anchorEl}
    keepMounted
    open
    onClose={handleClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
  >
    <MenuItem onClick={() => handleMarkUnlisted(repairId)}>{'Item not on manifest'}</MenuItem>
    <MenuItem onClick={() => handleMarkEmpty(repairId)}>{'Mark bag as empty'}</MenuItem>
    {handleMarkAsHighPriority !== null && (
      <MenuItem onClick={() => handleMarkAsHighPriority(repairId)}>{'Mark item as High Priority'}</MenuItem>
    )}
  </Menu>
);

export default RepairActionMenu;
